import { z } from 'zod'

import { ResidentUserRegistrationStatus } from '../types'
import { validationErrors, verificationCodeRegex } from './index'

export const getInvitationResponseSchema = z.object({
  email: z.string().nullable(),
  expired: z.boolean(),
  registrationStatus: z.nativeEnum(ResidentUserRegistrationStatus),
})

export type GetInvitationResponse = z.infer<typeof getInvitationResponseSchema>

export const registerInvitedUserInputSchema = z.object({
  password: z.string().min(8),
})

export type RegisterInvitedUserInput = z.infer<
  typeof registerInvitedUserInputSchema
>

export const registerInvitedUserResponseSchema = z.object({
  email: z.string(),
})

export type RegisterInvitedUserResponse = z.infer<
  typeof registerInvitedUserResponseSchema
>

export const verifyInvitedUserCodeInputSchema = z.object({
  verificationCode: z
    .string()
    .min(6)
    .refine((value) => verificationCodeRegex.test(value), {
      message: validationErrors.invalid_pin,
    }),
})

export type VerifyInvitedUserCodeInput = z.infer<
  typeof verifyInvitedUserCodeInputSchema
>

export const verifyInvitedUserCodeResponseSchema = z.object({
  success: z.boolean(),
})

export type VerifyInvitedUserCodeResponse = z.infer<
  typeof verifyInvitedUserCodeResponseSchema
>
